import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import type {ChartEventsDomainModel} from "./chart-events.domain-model";
import type {ChartEventTypeDomainModel} from "./event-type/chart-event-type.domain-model";
import type {ChartEventsStatusDomainModel} from "./status/chart-events-status.domain-model";
import {ChartEventTypeViewModel} from "./event-type/chart-event-type.view-model";
import {ChartEventsStatusViewModel} from "./status/chart-events-status.view-model";
import {EnumValueViewModel} from "../../../common/enum-value/models/enum-value.view-model";
import {EnumValueDomainModel} from "../../../common/enum-value/models/enum-value.domain-model";
import type {ChartEventDomainModel} from "./event/chart-event.domain-model";
import {ChartEventViewModel} from "./event/chart-event.view-model";
import {computed} from "mobx";

export class ChartEventsViewModel extends BaseViewModel {
  events: Array<ChartEventViewModel>;
  eventTypes: Array<ChartEventTypeViewModel>;
  statuses: Array<ChartEventsStatusViewModel>;
  eventSubTypes: Array<EnumValueViewModel>;

  constructor(model: ChartEventsDomainModel, isRtl: Boolean, isGameContext: Boolean) {
    super(model);

    this.events = model.events?.map((event: ChartEventDomainModel, index: Number) => new ChartEventViewModel(event, index, isRtl, isGameContext))
      .sort((a: ChartEventViewModel, b: ChartEventViewModel) => b.gameStartTime?.compare(a.gameStartTime));

    this.eventTypes = model.eventTypes?.map((type: ChartEventTypeDomainModel) => new ChartEventTypeViewModel(type));
    this.statuses = model.statuses?.map((status: ChartEventsStatusDomainModel) => new ChartEventsStatusViewModel(status));
    this.eventSubTypes = model.eventSubTypes?.map((subType: EnumValueDomainModel) => new EnumValueViewModel(subType));
  }

  @computed get hasShotsCoordination(): Boolean {
    let hasShotsCoordination = true;
    const noCoordinationEventExist = this.events.find(event => !event?.outcome?.hasShotCoordination);
    if(noCoordinationEventExist) {
      hasShotsCoordination = false;
    }

    return hasShotsCoordination;
  }
}
